import { ReactComponent as HugeiconsFileScript } from "app/components/Icons/WorkItemsIcon/hugeicons_file-script.svg";
import { ReactComponent as HugeiconsPuzzle } from "app/components/Icons/WorkItemsIcon/hugeicons_puzzle.svg";
import { ReactComponent as IconParkOutlineDocSearch } from "app/components/Icons/WorkItemsIcon/icon-park-outline_doc-search.svg";
import { ReactComponent as IconParkOutlineHashtagKey } from "app/components/Icons/WorkItemsIcon/icon-park-outline_hashtag-key.svg";
import { ReactComponent as IconParkOutlineRightRun } from "app/components/Icons/WorkItemsIcon/icon-park-outline_right-run.svg";
import { ReactComponent as IconParkOutlineSpanner } from "app/components/Icons/WorkItemsIcon/icon-park-outline_spanner.svg";
import { ReactComponent as LineMdSecurity } from "app/components/Icons/WorkItemsIcon/line-md_security.svg";
import { ReactComponent as ListView } from "app/components/Icons/WorkItemsIcon/list view.svg";
import { ReactComponent as LucideScanSearch } from "app/components/Icons/WorkItemsIcon/lucide_scan-search.svg";
import { ReactComponent as MajesticonsBookLine } from "app/components/Icons/WorkItemsIcon/majesticons_book-line.svg";
import { ReactComponent as MaterialSymbolsLightMap } from "app/components/Icons/WorkItemsIcon/material-symbols-light_map-search-outline-rounded.svg";
import { ReactComponent as MaterialSymbolsOpenRun } from "app/components/Icons/WorkItemsIcon/material-symbols_open-run-rounded.svg";
import { ReactComponent as MdiLightScript } from "app/components/Icons/WorkItemsIcon/mdi-light_script.svg";
import { ReactComponent as MdiFileSearchOutline } from "app/components/Icons/WorkItemsIcon/mdi_file-search-outline.svg";
import { ReactComponent as MdiPasswordOutline } from "app/components/Icons/WorkItemsIcon/mdi_password-outline.svg";
import { ReactComponent as OcticonCheckbox } from "app/components/Icons/WorkItemsIcon/octicon_checkbox-24.svg";
import { ReactComponent as OcticonFile } from "app/components/Icons/WorkItemsIcon/octicon_file-24.svg";
import { ReactComponent as PepiconsPencilArrows } from "app/components/Icons/WorkItemsIcon/pepicons-pencil_arrows-spin.svg";
import { ReactComponent as PhNotePencilLight } from "app/components/Icons/WorkItemsIcon/ph_note-pencil-light.svg";
import { ReactComponent as PhTarget } from "app/components/Icons/WorkItemsIcon/ph_target.svg";
import { ReactComponent as QlementineIconsFileScript } from "app/components/Icons/WorkItemsIcon/qlementine-icons_file-script-16.svg";
import { ReactComponent as SolarChart } from "app/components/Icons/WorkItemsIcon/solar_chart-2-linear.svg";
import { ReactComponent as StashLinkSolid } from "app/components/Icons/WorkItemsIcon/stash_link-solid.svg";
import { ReactComponent as Subgroup } from "app/components/Icons/WorkItemsIcon/subgroup.svg";
import { ReactComponent as TablerBook } from "app/components/Icons/WorkItemsIcon/tabler_book.svg";
import { ReactComponent as TablerLockSearch } from "app/components/Icons/WorkItemsIcon/tabler_lock-search.svg";
import { ReactComponent as TablerPencilCode } from "app/components/Icons/WorkItemsIcon/tabler_pencil-code.svg";
import { ReactComponent as Task } from "app/components/Icons/WorkItemsIcon/task.svg";
import { ReactComponent as TestCases1 } from "app/components/Icons/WorkItemsIcon/test cases 1.svg";
import { ReactComponent as TestCases2 } from "app/components/Icons/WorkItemsIcon/test cases 2.svg";
import { ReactComponent as TestCases } from "app/components/Icons/WorkItemsIcon/test cases.svg";
import { ReactComponent as UitRocket } from "app/components/Icons/WorkItemsIcon/uit_rocket.svg";
import { ReactComponent as UserStory } from "app/components/Icons/WorkItemsIcon/user story.svg";
import { ReactComponent as Bug } from "app/components/Icons/WorkItemsIcon/bug.svg";
import { ReactComponent as Epic } from "app/components/Icons/WorkItemsIcon/epic.svg";
import { ReactComponent as Block } from "app/components/Icons/WorkItemsIcon/carbon_error.svg";
import { ReactComponent as carbonBuildRun } from "app/components/Icons/WorkItemsIcon/carbon_build-run.svg";
import { ReactComponent as PepiconsPencilArrowsBlue } from "app/components/Icons/WorkItemsIcon/pepicons-pencil_arrows-spin-blue.svg";
import { ReactComponent as codiconRunAbove } from "app/components/Icons/WorkItemsIcon/codicon_run-above.svg";
import { ReactComponent as carbonRunMirror } from "app/components/Icons/WorkItemsIcon/carbon_run-mirror.svg";
import { ReactComponent as carbonBuildImage } from "app/components/Icons/WorkItemsIcon/carbon_build-image.svg";
import { ReactComponent as mdl2Build } from "app/components/Icons/WorkItemsIcon/fluent-mdl2_build-queue.svg";
import { ReactComponent as heroiconsWrench } from "app/components/Icons/WorkItemsIcon/heroicons_wrench-screwdriver.svg";
import { ReactComponent as f7Doc } from "app/components/Icons/WorkItemsIcon/f7_doc.svg";
import { ReactComponent as basilLightbulb } from "app/components/Icons/WorkItemsIcon/basil_lightbulb-outline.svg";
import { ReactComponent as ciChart } from "app/components/Icons/WorkItemsIcon/ci_chart-line.svg";
import { ReactComponent as heroiconsTicket } from "app/components/Icons/WorkItemsIcon/heroicons_ticket.svg";
import { ReactComponent as codiconRun } from "app/components/Icons/WorkItemsIcon/codicon_run-coverage.svg";
import { ReactComponent as gravityUi_Ticket } from "app/components/Icons/WorkItemsIcon/gravity-ui_ticket.svg";
import { ReactComponent as basil_book_check } from "app/components/Icons/WorkItemsIcon/basil_book-check-outline.svg";

export const workItemIcons = {
  task: Task,
  bug: Bug,
  story: UserStory,
  epic: Epic,
  icon_park_outline_spanner: IconParkOutlineSpanner,
  pepicons_pencil_arrows_spi: PepiconsPencilArrows,
  block: Block,
  mdi_password_outline: MdiPasswordOutline,
  octicon_checkbox_24: OcticonCheckbox,
  octicon_file_24: OcticonFile,
  list_view: ListView,
  test_cases: TestCases,
  test_cases_1: TestCases1,
  test_cases_2: TestCases2,
  subgroup: Subgroup,
  icon_park_outline_right_run: IconParkOutlineRightRun,
  carbon_build_run: carbonBuildRun,
  pepicons_pencil_arrows_spi_blue: PepiconsPencilArrowsBlue,
  codicon_run_above: codiconRunAbove,
  carbon_run_mirror: carbonRunMirror,
  mdi_file_search_outline: MdiFileSearchOutline,
  lucide_scan_search: LucideScanSearch,
  tabler_lock_search: TablerLockSearch,
  material_symbols_light_map: MaterialSymbolsLightMap,
  uit_rocket: UitRocket,
  carbon_build: carbonBuildImage,
  mdl2_build: mdl2Build,
  tabler_book: TablerBook,
  hugeicons_file_script: HugeiconsFileScript,
  heroicons_wrench: heroiconsWrench,
  qlementine_icons_file_script: QlementineIconsFileScript,

  tabler_pencil_code: TablerPencilCode,
  icon_park_outline_doc_search: IconParkOutlineDocSearch,
  hugeicons_puzzle: HugeiconsPuzzle,
  majesticons_book_line: MajesticonsBookLine,
  mdi_light_script: MdiLightScript,
  f7_doc: f7Doc,
  ph_note_pencil_light: PhNotePencilLight,
  ph_target: PhTarget,
  basil_lightbulb: basilLightbulb,
  stash_link_solid: StashLinkSolid,
  ci_chart: ciChart,
  solar_chart_2_linear: SolarChart,
  line_md_security: LineMdSecurity,
  heroicons_ticket: heroiconsTicket,
  codicon_run: codiconRun,
  material_symbols_open_run: MaterialSymbolsOpenRun,
  gravity_ui_ticket: gravityUi_Ticket,
  basil_book_check: basil_book_check,
  icon_park_outline_hashtag_key: IconParkOutlineHashtagKey,
};


export const workItemIconsColors = {
  task: '#0895CB',
  bug: '#EB5757',
  story: '#219653',
  epic: '#9B51E0',
  icon_park_outline_spanner: '#214EA5',
  pepicons_pencil_arrows_spi: '#7321CA',
  block: '#CE143C',
  mdi_password_outline: '#4EBDD6',
  octicon_checkbox_24: '#6A9CE3',
  octicon_file_24: '#2094AE',
  list_view: '#3B82F6',
  test_cases: '#7756C4',
  test_cases_1: '#F97316',
  test_cases_2: '#FACC15',
  subgroup: '#F59E0B',
  icon_park_outline_right_run: '#EC4899',
  carbon_build_run: '#06B6D4',
  pepicons_pencil_arrows_spi_blue: '#6366F1',
  codicon_run_above: '#14B8A6',
  carbon_run_mirror: '#C75F92',
  mdi_file_search_outline: '#06B6D4',
  lucide_scan_search: '#EF4444',
  tabler_lock_search: '#7192C1',
  material_symbols_light_map: '#14B8A6',
  uit_rocket: '#F59E0B',
  carbon_build: '#F59E0B',
  mdl2_build: '#32ED3E',
  tabler_book: '#64748B',
  hugeicons_file_script: '#6366F1',
  heroicons_wrench: '#1094B9',
  qlementine_icons_file_script: '#EC48BB',
  tabler_pencil_code: '#EF4444',
  icon_park_outline_doc_search: '#FACC15',
  hugeicons_puzzle: '#7963AB',
  majesticons_book_line: '#1BB037',
  mdi_light_script: '#10B981',
  f7_doc: '#06B6D4',
  ph_note_pencil_light: '#EC4899',
  ph_target: '#491DAC',
  basil_lightbulb: '#C60363',
  stash_link_solid: '#EC4899',
  ci_chart: '#3B82F6',
  solar_chart_2_linear: '#5579AC',
  line_md_security: '#3B82F6',
  heroicons_ticket: '#EF4444',
  codicon_run: '#26AAAF',
  material_symbols_open_run: '#FACC15',
  gravity_ui_ticket: '#F97316',
  basil_book_check: '#9970F5',
  icon_park_outline_hashtag_key: '#06B6D4',
};


export type WorkItemIconName = keyof typeof workItemIcons;
